<template>
	<div>
		<div class="foot-tab" :class="{'!rounded-b-none' : noCorners}">
			<div class="foot-tab-head">
				<div class="foot-tab-row-label">
					<span class="cursor-pointer underline zt-hover whitespace-nowrap min-w-[18px] pl-[10px]"
                @click="sortAscending = sortAscending === 0 ? 1 : 0; isLpSet = !isLpSet">L.p</span>
					<span class="cursor-pointer underline zt-hover truncate"
					      :class="{ '!no-underline' : sortColumn === 'name' }"
					      @click="sortTable('name', $event)">{{getTitleString(phaseString)}}</span>
				</div>
				<div class="flex">
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'matches' }"
					     @click="sortTable('matches', $event)"><div>M</div></div>
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'cleansheet' }"
					     @click="sortTable('cleansheet', $event)"><div>TAK</div></div>
					<div class="foot-tab-row-item"
					     :class="{ '!no-underline' : sortColumn === 'loss' }"
					     @click="sortTable('loss', $event)"><div>NIE</div></div>
					<div class="foot-tab-row-item !w-[50px]"
					     :class="{ '!no-underline' : sortColumn === 'bm' }"
					     @click="sortTable('bm', $event)"><div>B</div></div>
				</div>
			</div>
			<div class="foot-tab-row" :class="{ '!bg-zt-more/35' : selectedTeamsIds.includes(+team.team_id), '!border-b-0 !rounded-b-zt': index === leagueTable.length - 1 }"
			     v-for="(team, index) in leagueTable" :key="team.team_id">
				<div class="foot-tab-row-label" :class="{ '!bg-[#4d5a6d]' : selectedTeamsIds.includes(+team.team_id) }">
					<p class="flex items-center">
						<span class="inline-block w-[22px] !shrink-0">{{isLpSet ?  leagueTable.length - index : index + 1}}.</span>
            <a v-if="!selectedTeamsIds.includes(+team.team_id)"
               :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null"
               class="no-default-style" :class="{ 'zt-hover': team.clickable }">
              <span class="flex items-center mr-2 aspect-square h-5">
                <TeamImg :team="team"/>
              </span>
            </a>
            <span v-else class="flex items-center mr-2 aspect-square h-5">
              <TeamImg :team="team"/>
            </span>
						<a v-if="!selectedTeamsIds.includes(+team.team_id)"
               class="no-default-style text-ellipsis line-clamp-1 break-all" :class="{ 'zt-hover': team.clickable }"
               :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null">
              {{ team.short_name?.length > 0 ? team.short_name : team.name }}
            </a>
						<span v-else class="text-ellipsis line-clamp-1 break-all">
              {{ team.short_name?.length > 0 ? team.short_name : team.name }}
            </span>
					</p>
				</div>
        <transition appear name="fade" mode="out-in">
          <div :key="filterKey" class="flex">
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'matches' }">
              <div>{{ allMatches(team) }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'cleansheet' }">
              <div>{{ cleanSheet(team) }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'loss' }">
              <div>{{ allMatches(team) - cleanSheet(team) }}</div>
            </div>
            <div class="foot-tab-row-item !w-[50px]" :class="{ 'foot-tab-row-item-active' : sortColumn === 'bm' }">
              <div>{{ allGoals(team) }}</div>
            </div>
          </div>
        </transition>
			</div>
		</div>
	</div>
</template>

<script>
import football_mixin from '../../mixins/football_mixin';
import TeamImg from "../football_stats/blocks/TeamImg.vue";

export default {
	name: 'CleanSheetTable',
	components: {TeamImg},
	mixins: [football_mixin],
	props: {
    noCorners: {
      type: Boolean,
      default: false
    },
    phase: {
      type: String,
      default: ''
    },
		teams: Array,
		filters: Array,
		details: Object,
		selectedTeamsIds: {
			type: Array,
			default: []
		},
    view: {
      type: String,
      default: 'normal',
      validator: function (value) {
        return ['normal', 'compact'].includes(value);
      }
    }
	},
	data() {
		return {
			previousSortColumn: null,
			displayedTable: 'all',
			sortColumn: 'cleansheet',
			sortAscending: 0,
			isLpSet: false,
			currentSubTab: this.filters[1] ?? 'all',
			teamsSorted: [],
		}
	},
	mounted() {
		this.teamsSorted = this.teams;
		this.teamsSorted.sort(this.sortTeams).forEach((team, i) => { team.currentTablePosition = i + 1; });
	},
	computed: {
    rowHeight() {
      return this.view === 'compact' ? '28px' : '38px';
    },
    legendBarHeight() {
      return this.view === 'compact' ? '19px' : '30px';
    },
    filterKey() {
      return this.filters.join('-') + `-${ this.view }`;
    },
    phaseString() {
      return this.phase.replace('_', ' ');
    },
		leagueTable() {
			if (this.teamsSorted && this.teamsSorted.length > 0) {
				return this.teamsSorted.sort(this.sortTeams);
			}	else {
				return this.teamsSorted;
			}
		},
	},
	watch: {
		filters(newVal) {
			setTimeout(() => {
				this.currentSubTab = newVal[1];
				this.leagueTable.forEach((team, i) => { team.currentTablePosition = i + 1; });
			}, 200);
		}
	},
	methods: {
		sortTeams(a, b) {
			let diff = 0;
			if (this.sortColumn === 'name') {
				if (this.sortAscending) {
					diff = a.name.localeCompare(b.name);
				} else {
					diff = b.name.localeCompare(a.name);
				}
				return diff;
			}
			switch (this.sortColumn) {
				case 'loss':
					if (this.sortAscending) {
						diff = (this.allMatches(a) - this.cleanSheet(a)) - (this.allMatches(b) -this.cleanSheet(b));
					} else {
						diff = (this.allMatches(b) - this.cleanSheet(b)) - (this.allMatches(a) - this.cleanSheet(a));
					}
					break;
				case 'cleansheet':
					if (this.sortAscending) {
						diff = this.cleanSheet(a) - this.cleanSheet(b);
					} else {
						diff = this.cleanSheet(b) - this.cleanSheet(a);
					}
          if (diff === 0) {
            if (this.sortAscending) {
              diff = this.getPoints(a) - this.getPoints(b);
            } else {
              diff = this.getPoints(b) - this.getPoints(a);
            }
          }
					break;
				case 'points':
					if (this.sortAscending) {
						diff = this.getPoints(a) - this.getPoints(b);
					} else {
						diff = this.getPoints(b) - this.getPoints(a);
					}
					break;
				case 'matches':
					if (this.sortAscending) {
						diff = this.allMatches(a) - this.allMatches(b);
					} else {
						diff = this.allMatches(b) - this.allMatches(a);
					}
					break;
				case 'bm':
				default:
					if (this.sortAscending) {
						diff = +this.allGoals(a).split(':')[0] - +this.allGoals(b).split(':')[0] || +this.allGoals(b).split(':')[1] - +this.allGoals(a).split(':')[1];
					} else {
						diff = +this.allGoals(b).split(':')[0] - +this.allGoals(a).split(':')[0] || +this.allGoals(a).split(':')[1] - +this.allGoals(b).split(':')[1];
					}
					break;
			}
			return diff;
		},
		cleanSheet(team) {
			let allMatches = this.allMatches(team);
			if (allMatches > 0) {
				return this.getTeamMatches(team).reduce((sum, match) => {
					if (match.localteam_id === team.team_id) {
						if (+match.visitorteam_goals === 0) {
							return sum + 1;
						} else {
							return sum;
						}
					} else if (match.visitorteam_id === team.team_id) {
						if (+match.localteam_goals === 0) {
							return sum + 1;
						} else {
							return sum;
						}
					}
				}, 0);
			}
			return 0;
		},
	}
}
</script>

<style scoped>
.foot-tab-row-item {
  height: v-bind(rowHeight);
}

.foot-tab-row {
  height: v-bind(rowHeight);
}

.foot-tab-row-marked-red::before, .foot-tab-row-marked-red-variant::before,
.foot-tab-row-marked-blue::before, .foot-tab-row-marked-blue-variant::before,
.foot-tab-row-marked-purple::before, .foot-tab-row-marked-purple-variant::before,
.foot-tab-row-marked-green::before, .foot-tab-row-marked-green-variant::before {
  height: v-bind(legendBarHeight);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>